<script>
    import 'firebase/auth';
    import "firebase/firestore";
    import { getContext } from 'svelte';
    import { Routes, pushRoute } from '../router';
    import { getUrlParam } from '../utils';
    import { page } from '../stores';
    import PageTitle from '../components/PageTitle.svelte';

    const app = getContext('firebase').getFirebase();
    let auth = app.auth();
    const db = app.firestore();
    const token = getUrlParam('t');

    let _organizationID = '';

    function validateToken(token) {
        const milliseconds = Date.now();
        let tokenmilliseconds = '';

        for (let i = 0; i < token.length; i = i + 2) {
            tokenmilliseconds += token.substring(i, i + 1);
        }

        const parsed = parseInt(tokenmilliseconds, 10);
        if (isNaN(parsed)) {
            return false;
        }
        const oneHour = 3600000;
        return milliseconds - parsed < oneHour * 48;
    }

    if (!token || !validateToken(token) || auth.currentUser) {
        pushRoute(Routes.INDEX);
    } else {
        db.collection('inviteTokens').doc(`${token}`).get().then((doc) => {
            if (doc.exists) {
                const data = doc.data();
                if (data.used) {
                    pushRoute(Routes.INDEX);
                } else {
                    _organizationID = data.organizationID;
                }
            } else {
                pushRoute(Routes.INDEX);
            }
        }).catch((e) => {
            pushRoute(Routes.INDEX);
        });
    }

    let errorMessage = '';
    let firstName = '';
    let lastName = '';
    let email = '';
    let password1 = '';
    let password2 = '';
    $: disabled = !Boolean(/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(email)) || !password1 || password1 !== password2 || !firstName || !lastName;

    async function onCreateAccount() {
        if (disabled) {
            return;
        }
        const r = await auth.createUserWithEmailAndPassword(email, password1).catch((error) => {
            errorMessage = error.message;
        });

        const _firstName = firstName.trim();
        const _lastName = lastName.trim();
        await db.collection('users').doc(`${r.user.uid}`).set({
            organizationID: _organizationID,
            firstName: _firstName,
            lastName: _lastName,
        }, { 
            merge: true
        }).catch((e) => {
            console.log(e);
        });

        await db.collection('inviteTokens').doc(`${token}`).update({used: true}).catch((e) => {
            console.log(e);
        });
    }
</script>

<PageTitle text={'Create Account'} />
<div class='form-wrapper'>
    <form on:submit|preventDefault={onCreateAccount}>
        <input bind:value={firstName} type='text' placeholder='First Name'>
        <input bind:value={lastName} type='text' placeholder='Last Name'>
        <input bind:value={email} type='text' placeholder='Email'>
        <input bind:value={password1} type='password' placeholder='Password'>
        <input bind:value={password2} type='password' placeholder='Confirm Password'>
        <input type='submit' value='Create' disabled={disabled}>
    </form>
    {#if errorMessage}
        <div class='form-error-message'>
            <span>{errorMessage}</span>
        </div>
    {/if}
</div>

<style>
    input[type=text], input[type=password] {
        width: 100%;
    }

    input[type=text], input[type=password] {
        margin: 0px 0px 10px 0px;
    }

    input[type=submit] {
        margin-top: 10px;
    }

    input[type=submit]:hover {
        cursor: pointer;
    }

    input[type=submit]:disabled {
        background-color: var(--grey);        
    }
</style>
